// extracted by mini-css-extract-plugin
module.exports = {"header":"ShipmentAgent_header__1KvuS","title":"ShipmentAgent_title__2AHyb","small":"ShipmentAgent_small__1Biu7","btnContainer":"ShipmentAgent_btnContainer__lw-sT"};